<template>
  <div class="gsdet">
    <div class="gsdetc">
      <div class="tit">{{content.title}}</div>
      <div class="tim">公示时间：{{content.publishDate}}</div>
      <div class="con"  v-html="content.content">
      </div>
      <div class="jccj">
        <div class="cj-dvs">
          <div class="cj-item">
            <div class="sm-tit">
              <img width="15px" src="../../assets/yzjc/dianzan.png" alt="" />
              <div class="sm-num">{{content.agreeNum}}票</div>
            </div>
            <van-progress stroke-width="10" color="#39c12b" :percentage="percentage(content.agreeNum)" />
          </div>
          <div class="cj-item">
            <div class="sm-tit">
              <img width="15px" src="../../assets/yzjc/budian.png" alt="" />
              <div class="sm-num">{{content.opposeNum}}票</div>
            </div>
            <van-progress stroke-width="10" color="#f66b41" :percentage="percentage(content.opposeNum)" />
          </div>
          <div class="cj-item">
            <div class="sm-tit">
              <img width="15px" src="../../assets/yzjc/qizan.png" alt="" />
              <div class="sm-num">{{content.waiverNum}}票</div>
            </div>
            <van-progress stroke-width="10" color="#cacaca" :percentage="percentage(content.waiverNum)" />
          </div>
        </div>
      </div>
      <div class="jcjg">
        <div>决策结果 <span style="color:#39c12b;margin-left:20px">{{content.finalResult}}</span></div>
        
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import { RadioGroup, Radio, Toast, Progress } from "vant";
Vue.use(Radio);
Vue.use(RadioGroup);
Vue.use(Toast);
Vue.use(Progress);
export default {
  data() {
    return {
		 content:{
			 
		 },
	};
  },
  computed:{
	  total(){
		  return Number(this.content.agreeNum)+Number(this.content.opposeNum)+Number(this.content.waiverNum);
	  }
  },
  mounted() {
	  this.id = this.$route.query.id;
	  this.$axios.get('/api/v1/wechat/yzjc/gsgl/'+this.id).then(res => {
	  	this.content=res;
	  });
  },
  methods: {
	  percentage(val){
		  if(this.total==0){
			  return 0
		  }else{
			  return Number(val)/this.total.toFixed(2)*100
		  }
	  }
  },
};
</script>
<style lang="less">
.gsdet {
  width: 100%;
  // display: flex;
  height: 100%;
  display: flex;
  background-color: #fff;
  flex-direction: column;
  align-items: center;
  .gsdetc {
    width: calc(100% - 6%);
    // height: 98%;
    display: flex;
    flex-direction: column;
    justify-content: space-around;
    align-items: center;
    .tit {
      font-size: 18px;
      color: #515151;
      margin: 10px auto;
    }
    .tim {
      font-size: 13px;
      color: #a2a2a2;
      margin: 10px auto;
      margin-top: -10px;
    }
    .con {
      text-indent: 2em;
      width: 100%;
      line-height: 30px;
      box-shadow: 0px 0px 2px 0px rgba(84, 84, 84, 0.43);
      border-radius: 7px;
      padding: 20px;
      margin: 10px auto;
      .jiao {
        text-indent: 0;
        color: #a2a2a2;
        font-size: 13px;
        margin-left: 50%;
      }
    }
    .info {
      margin: 10px auto;
      margin-left: 5%;
      div {
        margin-bottom: 10px;
      }
    }
    .jccj {
      width: 100%;
      .cj-dvs {
        width: 100%;
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        .cj-item {
          width: 33%;
          // border: 1px solid red;
          .sm-tit {
            display: flex;
            flex-direction: row;
            justify-content: center;
            align-items: center;
            margin-bottom: 10px;
            .sm-num {
              font-size: 15px;
              color: #8c8c8c;
              margin-left: 10px;
            }
          }
        }
      }
      .xiao-tit {
        text-decoration: underline;
        font-size: 15px;
        margin-top: 13px;
        // margin-bottom: 13px;
        color: #ff890a;
      }
    }
    .jcjg {
      width: 100%;
  margin-top: 20px;
    }
  }
}

</style>